import React from "react";

const DirecthistoryCard = ({ item }) => {
  return (
    <div className="bg-white rounded-3 p-3 shadow mt-2">
      <h5>{item.game_name}</h5>
      <h6>{item.game_type}</h6>
      <div className="flex-row d-flex justify-content-between">
        <label className="col-3">Left Digits</label>
        <label className="col-3">Right Digits</label>
        <label className="col-3">Amount</label>
        <label className="col-3">Total</label>
      </div>
        <div className="flex-row d-flex justify-content-between">
            <label className="col-3">{item.left_digit}</label>
            <label className="col-3">{item.right_digit}</label>
          <label className="col-3">{item.amount}</label>
          <label className="col-3">{item.amount}</label>
        </div>
    </div>
  );
};

export default DirecthistoryCard;
